import { render, staticRenderFns } from "./LightboxCarousel.vue?vue&type=template&id=2268414f"
import script from "./LightboxCarousel.vue?vue&type=script&lang=ts"
export * from "./LightboxCarousel.vue?vue&type=script&lang=ts"
import style0 from "./LightboxCarousel.vue?vue&type=style&index=0&id=2268414f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports